import React, { useEffect, useRef } from 'react';
import { ISpinner } from './Spinner.i';
import { cn } from '../cn';

export const Spinner = ({ loading=true, children, className }: ISpinner) => {
  return (
    <React.Fragment>
      {loading
        && <div className='h-96 w-full flex justify-center items-center'>
          <SpinnerInline className={className}/>
        </div>
      }
      {!loading && children}
    </React.Fragment>
  );
};

export const SpinnerInline = ({ className }: ISpinner & {className?: string}) => {
  const bar1Ref = useRef<HTMLDivElement>(null);
  const bar2Ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const animateBar1 = () => {
      const keyframes = [
        { left: '-100%', right: '-10%', offset: 0 },
        { left: '100%', right: '-90%', offset: 1 }
      ];
      
      const timing = {
        duration: 3000,
        iterations: Infinity,
        easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)'
      };
      
      if (bar1Ref.current) {
        bar1Ref.current.animate(keyframes, timing);
      }
    }
    const animateBar2 = () => {
      const keyframes = [
        { left: '-100%', right: '-10%', offset: 0 },
        { left: '100%', right: '-90%', offset: 1 }
      ];
      
      const timing = {
        duration: 3000,
        iterations: Infinity,
        easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)'
      };
      setTimeout(() => {
        if (bar2Ref.current) {
          bar2Ref.current.animate(keyframes, timing);
        }
      }, 1500);
    }
    animateBar1();
    animateBar2();
  }, []);
  return <div className={cn('relative w-full m-auto overflow-hidden h-2 bg-surface-dark', className)} style={{
    maxWidth: 'min(90vw, 300px)'
  }}>
    <div className="absolute left-0 top-0 bottom-0 right-0 border-1 border-surface-darker inset-0.5"></div>
    <div ref={bar1Ref} className='absolute w-full h-2 top-0 bottom-0 bg-gradient-to-r from-transparent via-sc-gold-50 to-transparent opacity-40'/>
    <div ref={bar2Ref} className='absolute w-full h-2 top-0 bottom-0 bg-gradient-to-r from-transparent via-sc-gold-50 to-transparent opacity-40'/>
  </div>
};